import { render } from "./DropzoneComponent.vue?vue&type=template&id=b0de791c"
import script from "./DropzoneComponent.vue?vue&type=script&lang=js"
export * from "./DropzoneComponent.vue?vue&type=script&lang=js"

import "./DropzoneComponent.vue?vue&type=style&index=0&id=b0de791c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__